import "reflect-metadata"
import { injectable } from 'inversify-props';
import { getIBS, findIBS } from '@/api/impostos';
import { ServiceIBSAdapter } from "@/usecases";


@injectable()
export class IBSService implements ServiceIBSAdapter {
	get = async (id: string) => await getIBS(id)
	find = async(params: any) => await findIBS(params)
}